import { environment } from "src/environments/environment.development";
export class AppConfiguration {
    // API URLs
    public static BASE_URL = environment.base_url;

    //EX CONF LOCALE
   // public static SECURED = AppConfiguration.BASE_URL + 'qrsp30-api';
   // public static COMMONS = AppConfiguration.BASE_URL + 'qrsp30-api/commons';

    //PROD LASCIARE QUESTO ANCHE IN LOCALE
   public static SECURED = AppConfiguration.BASE_URL + '/qrsp/secured/qrsp30-api';
   public static COMMONS = AppConfiguration.BASE_URL + '/qrsp/qrsp30-api/commons';
}
